import AxiosInstanceCreator from 'services/api';
import qs from 'qs';
const authInstance = new AxiosInstanceCreator().create();

export const ptwFormApi = {
  async getPtwFormInfo(formCode: any) {
    return await authInstance.get(`/ptw/form/info?formCode=${formCode}`).then((res) => res.data);
  },
  async getPtwFormList() {
    return await authInstance.get(`/ptw/form/list`).then((res) => res.data);
  },
  async getSignedUser(ptwMSeq: number) {
    return await authInstance
      .get(`/ptw/form/getSignedUser`, {
        params: { ptwMSeq }
      })
      .then((res) => res.data);
  }
};
